var React = require('react');

function Dragger (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cy":"6","cx":"3","r":"1","key":0}),React.createElement("circle",{"cy":"6","cx":"10","r":"1","key":1}),React.createElement("circle",{"cy":"6","cx":"17","r":"1","key":2}),React.createElement("circle",{"cy":"6","cx":"24","r":"1","key":3}),React.createElement("circle",{"cy":"12","cx":"3","r":"1","key":4}),React.createElement("circle",{"cy":"12","cx":"10","r":"1","key":5}),React.createElement("circle",{"cy":"12","cx":"17","r":"1","key":6}),React.createElement("circle",{"cy":"12","cx":"24","r":"1","key":7})]);
}

Dragger.defaultProps = {"className":"index-module__2Cp2d","width":"32","height":"18","viewBox":"0 0 26 18","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Dragger;

Dragger.default = Dragger;
